/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanOrEqualVersion: core.serialization.ObjectSchema<
    serializers.GreaterThanOrEqualVersion.Raw,
    Truvity.GreaterThanOrEqualVersion
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanOrEqualVersion {
    export interface Raw {
        value: number;
    }
}
